import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImageDesktopWebp from './images/samuel-s-daggett-desktop.webp';
import financialPlanningImageMobileWebp from './images/samuel-s-daggett-mobile.webp';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='who-we-are-financial-planning-3'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent
      // content
      subHeadingText={<>We believe in being at our best&#8212;even when things look <WidowBlock>their worst.</WidowBlock></>}
      // column content
      columnContentA={(
        <Typography disableBottomPadding>
          The year was 1859. An ox and a passenger train collided just outside Johnson Creek, Wisconsin, and two of our policyowners lost their lives in the wreck. The claims totaled &#36;3,500, which was &#36;1,500 more than our two&#45;year&#45;old company had on hand. Our then&#45;President, Samuel S. Daggett, and his fellow trustees personally borrowed the money to settle the claims, proving that our dedication to our clients has been around as long as the company itself.
        </Typography>
      )}
      // image props
      imageAltText='A sharply dressed financial advisor.'
      imageSrcDefault={financialPlanningImageDesktopWebp}
      imageSrcMobile={financialPlanningImageMobileWebp}
    />
  );
};
